import { render, staticRenderFns } from "./add_Price.vue?vue&type=template&id=2a51474a&scoped=true"
import script from "./add_Price.vue?vue&type=script&lang=js"
export * from "./add_Price.vue?vue&type=script&lang=js"
import style0 from "./add_Price.vue?vue&type=style&index=0&id=2a51474a&prod&scoped=true&lang=css"
import style1 from "./add_Price.vue?vue&type=style&index=1&id=2a51474a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a51474a",
  null
  
)

export default component.exports